module.exports = __webpack_public_path__ + "static/media/sunny.80841241.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/avatars/sunny.png
 ** module id = 33
 ** module chunks = 0
 **/